<template>
    <div>
        <v-card-actions>
            <router-link to="/resources">
                <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }"> Back </v-btn>
            </router-link>
        </v-card-actions>
        <!-- Carrusel de imágenes -->
        <v-carousel cycle height="500" hide-delimiters>
            <v-carousel-item v-for="(image, index) in card.images" :key="index">
                <v-responsive height="100%" max-width="800" class="mx-auto d-flex">
                    <v-img class="align-end text-white" contain height="100%" :src="require(`../assets/${image}`)"></v-img>
                </v-responsive>
            </v-carousel-item>
        </v-carousel>
        <!-- Título y subtítulo -->
        <h1>{{ card.title }}</h1>
        <h3>{{ card.subtitle }}</h3>
        <v-divider></v-divider>
        <!-- Descripción -->
        <v-spacer></v-spacer>
        <br>
        <p>
            <a href="https://www.unodc.org/unodc/en/corruption/publications.html" target="_blank">
                https://www.unodc.org/unodc/en/corruption/publications.html
            </a>
        </p>
        <b>Prevention and fight against corruption</b>
        <br><br>
        <p>UNITED NATIONS CONVENTION ON ANTICORRUPTION (UNCAC): RATIFICATION AND IMPLEMENTATION OF</p>
        <ul>
            <li>United Nations Convention against Corruption (UNCAC)</li>
            <li>Legislative Guide for the Implementation of UNCAC</li>
            <li>Technical Guide to the United Nations Convention against Corruption</li>
            <li>State of implementation of the United Nations Convention against Corruption - Criminalization, Law Enforcement and International Cooperation</li>
            <li>Set of non-binding recommendations and conclusions based on lessons learned regarding the implementation of chapters III and IV of the United Nations Convention against Corruption</li>

        </ul>
        <br><br>
        <p>THE CONFERENCE OF THE STATES PARTIES TO UNCAC AND ITS WORKING GROUPS</p>
        <ul>
            <li>Rules of Procedure for the Conference of the States Parties to the United Nations Convention against Corruption</li>
            <li>Documents on the sessions of the Conference of the States Parties to the United Nations Convention against Corruption</li>
            <li>Documents on the sessions of the Implementation Review Group of the United Nations Convention against Corruption</li>
            <li>Documents on the sessions of the Open-ended Intergovernmental Working Group on Prevention</li>
            <li>Documents on the sessions of the Open-ended Intergovernmental Working Group on Asset Recovery</li>
        </ul>
        <br><br>
        <h2>RESOURCES - FILES</h2>
        <v-card-actions>
      <!-- Otros botones -->
      <v-btn :style="{ color: 'white', 'background-color': 'rgb(15, 135, 201)' }" @click="openPdf"> PDF </v-btn>
    </v-card-actions>

    <!-- Utiliza target="_blank" para abrir en una nueva pestaña -->
    <a href="../assets_PDF/PDF.pdf" target="_blank">Abrir PDF</a>
        <br><br>
        <v-card-actions>
            <v-btn :style="{ color: 'white', 'background-color': 'rgb(127, 127, 127)' }" :href="card.link" target="_blank">Link</v-btn>
            <v-btn :style="{ color: 'white', 'background-color': 'rgb(15, 135, 201)' }"> PDF </v-btn>
        </v-card-actions>
    </div>
</template>
<script>
export default {
    data() {
        return {
            card: {
                id: 0,
                title: '',
                subtitle: '',
                description: '',
                additionalInfo: '',
                images: [],
                chip: [],
            },
            showPdf: false,
            cards: [
                {
                    id: 1,
                    title: 'UNODC Global',
                    subtitle: 'UNODC',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 1',
                    images: ['logo2.png', 'logo.png'],                    
                    chip: ['8:00 AM', '10:00 AM', '2:00 PM', '4:00 PM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/0.%20UNODC%20Global?csf=1&web=1&e=8Sy2kH',
                },
                {
                    id: 2,
                    title: 'Centro de Excelencia INEGI UNODC',
                    subtitle: 'INEGI',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 2',
                    images: ['logo.png', 'logo2.png'],                    
                    chip: ['7:00 AM', '9:00 AM', '11:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/Centro%20de%20Excelencia%20INEGI%20UNODC?csf=1&web=1&e=dLIVXd',
                },
                {
                    id: 3,
                    title: 'UNESCO rule of law through education',
                    subtitle: 'UNESCO',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 3',
                    images: ['logo.png', 'logo2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                    link: 'https://unitednations-my.sharepoint.com/:f:/r/personal/jhon_castrolopez_un_org/Documents/LABCC/Corruption/UNESCO%20rule%20of%20law%20through%20education?csf=1&web=1&e=3Dt35A',
                },
                {
                    id: 4,
                    title: 'UNICEF LACRO',
                    subtitle: 'UNICEF',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 4',
                    images: ['logo2.png', 'logo.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
                {
                    id: 5,
                    title: 'UNODC - Bolivia',
                    subtitle: 'Bolivia',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 5',
                    images: ['logo.png', 'logo2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
                {
                    id: 6,
                    title: 'UNODC - Brazil',
                    subtitle: 'Brazil',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 6',
                    images: ['logo2.png', 'logo.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
                {
                    id: 7,
                    title: 'UNODC - Mexico',
                    subtitle: 'Mexico',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit',
                    additionalInfo: 'Additional Info for Card 7',
                    images: ['logo.png', 'logo2.png'],
                    chip: ['7:00 AM', '9:00 AM'], 
                },
            ],
        };  
    },
    methods: {
        getImageSrc(filename) {
            return require(`../assets/${filename}`);
        },
        openPdf() {
            this.showPdf = true;
        },
    },
    created() {
        const cardId = parseInt(this.$route.params.id);
        this.card = this.cards.find(card => card.id === cardId);
    },
};
</script>